import type { Graph, ConceptTask } from "@lr-notitia/notitia-engineer/schemas";
import { Ref, computed } from "vue";
import { useSymbolsStore } from "../symbols";
import * as Metrics from "../metrics";

let symbolsStore: ReturnType<typeof useSymbolsStore>;
function init() {
	symbolsStore = useSymbolsStore();
}

export const conceptTasks = (graph: Ref<Graph>) =>
	computed<ConceptTask[]>(() => {
		if (!symbolsStore) init();
		return (
			Object.values(graph.value.nodes).filter(
				(node) => node.type === "task" && node.layer === "concept"
			) as ConceptTask[]
		).sort((a, b) =>
			symbolsStore
				.term({ id: a.refersTo, terminology: a.terminology || {} })
				.toLocaleLowerCase()
				.localeCompare(
					symbolsStore.term({ id: b.refersTo, terminology: b.terminology || {} }).toLocaleLowerCase()
				)
		);
	});

export function conceptTask(domainId: Ref<string>, graph: Ref<Graph>) {
	return {
		byId: (id: string) => {
			Metrics.recordAccess(id);
			return graph.value.nodes[id] as ConceptTask | undefined;
		},
	};
}
